(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("98VAx", function(module, exports) {
const $6a818840637bcd20$var$iframeWrapper = document.querySelector(".s-tickets__goout");
if (!$6a818840637bcd20$var$iframeWrapper) {
    const tickets = document.querySelectorAll(".i-ticket[data-goout-id]");
    tickets?.forEach((ticket)=>{
        const button = ticket.querySelector(".i-ticket__cta");
        const urlString = button?.getAttribute("href") ?? null;
        const url = urlString ? new URL(urlString) : null;
        const input = ticket.querySelector(".c-counter__input");
        input?.addEventListener("change", ()=>{
            const value = input.value;
            url?.searchParams.set("count", value);
            button?.setAttribute("href", url?.toString() ?? "");
        });
    });
}

});

})();
//# sourceMappingURL=ticket-item.7a26b9c3.js.map
